export default __webpack_public_path__ + "0ad8cc8c3c9af3f67b804b60715f7222.jpg";